<template>
  <span class="reason" :class="reasonClass">{{order.mys_reason}}</span>
</template>
<script>
export default {
  name: 'OrderReasonHighlighter',
  props: {
    order: {},
  },
  computed:{
    reasonClass(){
      var r = this.order.mys_reason;

      if(this.contains("fodselsdag"))
        return "reason-red";


      if(this.contains("bryllup"))
        return "reason-purple";
      
      if(this.contains("studenterfest"))
        return "reason-turquise";
      
      if(this.contains("konfirmation"))
        return "reason-blue";

      if(this.contains("julefrokost") ||
          this.contains("firmafest") ||
          this.contains("erhverv") ||
          this.contains("jubilæum")
      ) 
        return "reason-brown";
      
      return "reason-black";
    }
  },
  methods:{
    contains(str){
      if(!this.order || !this.order.mys_reason)
        return false;
      
      return this.order.mys_reason.indexOf(str) > -1;
    }
  }
}
</script>
<style>

.reason {
  font-size: x-large;
  font-weight: bold;
  padding: 5px 10px 5px;
  text-transform: uppercase;
}

.reason-purple{
  color:white;
  background:purple;
}

.reason-red{
  color:white;
  background:red;
}

.reason-turquise{
  color:white;
  background:turquoise;
}

.reason-blue{
  color:white;
  background:blue;
}

.reason-brown{
  color:white;
  background:saddlebrown;
}

.reason-black{
  color:white;
  background:black;
}
</style>